import { ButtonPassThrough } from 'primeng/button';

export const LinkButtonTelekomPT: ButtonPassThrough = {
  root: { class: 'pl-0!' },
  label: { class: 'underline' },
};
